export default {
    INPUT_TYPES: {
        INPUT: 'input',
        TEXT_AREA: 'text_area',
        SELECT: 'select',
        TOGGLE: 'toggle',
        RADIAL_BUTTONS: 'radial_buttons',
        COLOR: 'color',
        CALENDAR: 'calendar',
        SUBTITLE: 'subtitle',
    },
    INPUT_FIELDS: {
        FILE_UPLOADER: 'fileUploader',
        DATE_TIME: 'dateTime',
        ORDER: 'order',
        BUYER_SELECT: 'buyerSelect',
        POINTS: 'points',
        CURRENT_TOGGLE: 'currentToggle',
        NAME: 'name',
        NAME_CLASS_GRADE: 'nameClassGrade',
        FIRST_NAME: 'firstName',
        LAST_NAME: 'lastName',
        GENDER: 'gender',
        BIRTHDAY: 'birthday',
        CPF: 'cpf',
        DOCUMENT: 'document',
        EMAIL: 'email',
        PHONE_NUMBER: 'telephone',
        POSTALCODE: 'postalCode',
        ADDRESS: 'address',
        ADDRESS_NUMBER: 'addressNumber',
        ADDRESS_COMPLEMENT: 'addressComplement',
        NEIGHBORHOOD: 'neighborhood',
        COUNTRY: 'country',
        STATE: 'state',
        CITY: 'city',
        LEVEL_SELECT: 'levelSelect',
        TEACHER_SELECT: 'teacherSelect',
        POOL_SELECT: 'poolSelect',
        UNIT_SELECT: 'unitSelect',
        UNIT_SELECT_SIMPLE: 'unitSelectSimple',
        UNIT_TYPE_SELECT: 'unitTypeSelect',
        ENTITY_SELECT: 'entitySelect',
        PLAN_SELECT: 'planSelect',
        CUSTOMER_SUCCESS_SELECT: 'customerSuccessSelect',
        SITUATION_SELECT: 'situationSelect',
        PEDAGOGIC_TYPE_SELECT: 'pedagogicTypeSelect',
        CALENDAR_SELECT: 'calendarSelect',
        STAFF_SELECT: 'staffSelect',
        CLIENT_SELECT: 'clientSelect',
        MONTHLY_FEE: 'monthlyFee',
        REGISTRATION: 'registration',
        PLATFORM_ACCESS_TOGGLE: 'platformAccessToggle',
        POOL_DESCRIPTION: 'poolDescription',
        POOL_LENGTH: 'poolLength',
        POOL_WIDTH: 'poolWidth',
        POOL_DEPTH: 'poolDepth',
        NUMBER_OF_STUDENTS: 'numberOfStudents',
        CLASS_START_TIME: 'classStartTime',
        CLASS_END_TIME: 'classEndTime',
        WEEKDAYS: 'weekdays',
        TRADING_NAME: 'tradingName',
        COMPANY_NAME: 'companyName',
        STATE_REGISTRATION: 'stateRegistration',
        MUNICIPAL_REGISTRATION: 'municipalRegistration',
        PERSONAL_WEBSITE: 'personalWebsite',
        FACEBOOK: 'facebook',
        INSTAGRAM: 'instagram',
        CALENDAR_DESCRIPTION: 'calendarDescription',
        LANGUAGE_SELECT: 'languageSelect',
        PLAN_LIMIT_STUDENTS_TOGGLE: 'planLimitStudentsToggle',
        PLAN_LIMIT_STUDENTS_INPUT: 'planLimitStudentsInput',
        PLAN_LIMIT_STAFF_TOGGLE: 'planLimitStaffToggle',
        PLAN_LIMIT_STAFF_INPUT: 'planLimitStaffInput',
        PLAN_DESCRIPTION: 'planDescription',
        PLAN_COLOR: 'planColor',
        PORTUGUESE_LANGUAGE: 'portugueseLanguage',
        ENGLISH_LANGUAGE: 'englishLanguage',
        SPANISH_LANGUAGE: 'spanishLanguage',
        ASSESSMENT_QUESTION: 'assessmentQuestion',
        ASSESSMENT_QUESTION__ITEM: 'assessmentQuestionItem',
        ASSESSMENT_QUESTION__ITEM_GRADE: 'assessmentQuestionItemGrade',
        ASSESSMENT_QUESTION__ITEM_TYPE_SELECT:
            'assessmentQuestionItemTypeSelect',
        ACCREDITED_NAME: 'accreditedName',
        INITIAL_DATE: 'initialDate',
        END_DATE: 'endDate',
        RANGE_DATE: 'rangeDate',
        GOALS_SELECT: 'goalsSelect',
        CONTENTS_SELECT: 'contentsSelect',
        PERMISSION_SELECT: 'permissionSelect',
        PARTNER_SELECT: 'partnerSelect',
    },
    INPUT_RULES: {
        IMAGE: 'image',
        REQUIRED: 'required',
        EMAIL: 'email',
        VALID_DATE: 'valid-date',
        DATE_FORMAT: 'date-format',
        VALID_HOUR: 'valid-hour',
        POSITIVE_NUMBER: 'positive-number',
        ONLY_ACTIVE: 'only-active',
        VALID_CPF: 'valid-cpf',
        VALID_CNPJ: 'valid-cnpj',
        RACIONAL_VALUE: 'racional-value',
        DATE_FROM_TODAY: 'date-from-today',
        SPECIAL_CHARACTERS: 'special-characters',
    },
    ROLES: {
        ADMIN: 'Admin',
        OWNER: 'Owner',
        MANAGER: 'Manager',
        COORDINATOR: 'Coordinator',
        TEACHER: 'Teacher',
        SECRETARY: 'Secretary',
        STAFF: 'Staff',
        CUSTOMER_SUCCESS: 'CustomerSuccess',
        SUPPORT: 'Support',
        ASSESSOR: 'Assessor',
        EDUCATOR: 'Educator',
        DEVELOPER: 'Developer',
        MARKETING: 'Marketing',
    },
}
